import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import showObject from '../../../utils/showObject';
import LanguageTabsForms from '../../Tabs/LanguageTabsForms';
import imageModifier from '../../../utils/imageModifier';
import TagsInput from '../StructureComponents/TagsInput';

const ActiveTag = ({ title, callback }) => (
  <span className="cursor-pointer bg-gray200 py-1 px-2 mr-2 mb-2 font-americaMonoBold text-xs rounded-lg flex items-center uppercase text-white">
    <div className="flex justify-center" onClick={() => (callback ? callback(title) : null)}>
      {callback ? 'X' : ''}
      {' '}
      {title}
    </div>
  </span>
);

const MamObjectFormMultiple = ({
  objState: {
    fileReadableName, assetSlugName, url, fileExtension, description, type, isPublic, tags,
  }, inputObjHandler, imgCount, saveObject, close, deleteObject, editor, makePublicHandler, makePublicHandlerMultiple, toggleTagMultiple, toggleTag, index, canEditMultiple, inputObjHandlerMultiple,
}) => {
  const [objectUrl, setObjectUrl] = useState();
  const [isMultipleEdit, setIsMultipleEdit] = useState(canEditMultiple);

  useEffect(() => {
    if (!isPublic) {
      showObject(`${assetSlugName}`, fileExtension, true).then((res) => {
        setObjectUrl(res);
      });
    } else {
      setObjectUrl(url);
    }
  });

  useEffect(() => {
    setIsMultipleEdit(canEditMultiple);
  }, [canEditMultiple]);

  const handleTags = (name) => {
    if (isMultipleEdit) {
      toggleTagMultiple(name);
    } else {
      toggleTag(name, index);
    }
  };

  const handleInputObj = (e) => {
    if (isMultipleEdit) {
      inputObjHandlerMultiple(e);
    } else {
      inputObjHandler(e, index);
    }
  };

  const handlePublicState = () => {
    if (isMultipleEdit) {
      makePublicHandlerMultiple(!isPublic);
    } else {
      makePublicHandler(!isPublic, index);
    }
  };

  return (
    <div className="bg-black flex rounded-lg p-7 items-start mt-2 pb-6 justify-center">
      <div className="relative">
        {type === 'image' && (
        <div className="bg-cover relative flex flex-col justify-center pr-8">
          {canEditMultiple ? <span className="absolute text-5xl font-americaMonoRegular text-white center-absolute">{imgCount}</span> : null}
          <img src={imageModifier(objectUrl, '280x280')} className={`w-lineupHour h-280px object-cover rounded self-start ${canEditMultiple ? 'backgroundImgGray' : ''}`} alt={fileReadableName && fileReadableName.en} />
          {editor && (
          <button className="font-americaMonoBold text-xs px-4 py-1 rounded-full border-white border-1 bg-black text-white uppercase mt-3 font-extrabold w-170px flex flex-row justify-center items-center" onClick={deleteObject} type="button">
  Delete Image
            <span className="font-icon text-white icon-trash text-base pl-3" />
          </button>
          )
        }
        </div>
        )}
        { type === 'audio' && (
        <div className="relative flex flex-col justify-center pr-8 pt-7">
          <audio className="h-10 w-lineupHour" src={objectUrl} controls />
          {editor && (
          <button className="font-americaMonoBold text-xs px-4 py-1 rounded-full border-white border-1 bg-black text-white uppercase mt-6 font-extrabold w-170px flex flex-row justify-center items-center" onClick={deleteObject} type="button">
  Delete Audio
            <span className="font-icon text-white icon-trash text-base pl-3" />
          </button>
          )
      }
        </div>
        )
    }
        { type === 'video' && (
        <div className="relative flex flex-col justify-center pr-8 pt-7 w-min-content">
          <video className="w-lineupHour" src={objectUrl} controls />
          {editor && (
          <button className="font-americaMonoBold text-xs px-4 py-1 rounded-full border-white border-1 bg-black text-white uppercase mt-6 font-extrabold w-170px flex flex-row justify-center items-center" onClick={deleteObject} type="button">
  Delete Video
            <span className="font-icon text-white icon-trash text-base pl-3" />
          </button>
          )
      }
        </div>
        )
    }
        {type === 'file' && (
        <div className="pr-6 w-64 h-30 flex justify-center items-center">
          <div className="bg-cover relative flex flex-col justify-center align-center items-center">
            <span className="font-icon icon-file text-70 text-center" />
          </div>
          <div>
            {editor && (
            <button className="font-americaMonoBold text-xs px-4 py-1 rounded-full border-white border-1 bg-black text-white uppercase mt-6 font-extrabold w-170px flex flex-row justify-center items-center" onClick={deleteObject} type="button">
  Delete File
              <span className="font-icon text-white icon-trash text-base pl-3" />
            </button>
            )
        }
          </div>
        </div>
        )}
        <div className="mt-3 pb-0">
          <label className="switch mb-0 pb-0 h-6">
            <input
              className="switch"
              checked={isPublic}
              onChange={handlePublicState}
              type="checkbox"
            />
            <div className="switch-slider btn-public switch-round" />
          </label>
          {isPublic && (
            <div className={`${!editor ? 'pt-13' : 'mt-5'}`}>
              <p className="text-xs font-americaMonoRegular uppercase my-0 py-0">URL File</p>
              <p className={`text-xs font-americaMonoRegular lowercase break-all my-0 py-0 w-lineupHour text-white pt-2 ${type === 'file' && 'max-w-240'}`}>{objectUrl}</p>
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col text-xs font-americaMonoRegular uppercase text-white flex flex-col">
        <div>
          <LanguageTabsForms fileReadableName={fileReadableName} activeTabStyle="tab active" tabStyle="">
            {
          (activeLanguage, languages) => (
            languages.map(lang => (
              <div key={lang} className={`w-full ${activeLanguage === lang ? 'block' : 'hidden'} p-4 bg-greyWithinForm rounded-b-lg p-7 pb-5`}>
                <div className="text-xs font-americaMonoRegular text-white flex flex-col">
                  TITLE
                  <input
                    className="font-americaMonoRegular rounded-full py-1 pl-4 outline-none mt-4 mb-6 text-sm font-americaMonoRegular w-full h-10"
                    name="fileReadableName"
                    value={fileReadableName[lang] || ''}
                    onChange={handleInputObj}
                    lang={lang}
                    type="text"
                    disabled={canEditMultiple}
                  />
                </div>
                <div className="text-xs font-americaMonoRegular text-white flex flex-col">
                  DESCRIPTION
                  <textarea
                    className="font-americaMonoRegular rounded-lg py-1 pl-4 outline-none mt-4 mb-6 text-sm font-americaMonoRegular w-full h-lineupHour"
                    name="description"
                    value={description[lang] || ''}
                    lang={lang}
                    onChange={handleInputObj}
                    type="text"
                  />
                </div>
                {/* <input className="font-americaMonoRegular p-2 bg-white outline-none w-full" name="description" value={objState.description.lang} lang={lang} type="text" /> */}
              </div>
            ))
          )
        }
          </LanguageTabsForms>
          <div className="w-full mt-4">
            <TagsInput toggleTag={handleTags} />
            <div className="h-16 my-4">
              <div className="flex flex-wrap">
                {tags && tags.map(tag => (
                  <ActiveTag key={tag} callback={handleTags} title={tag} />
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="flex flex-row justify-end pt-4">
          <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full border-white border-1 bg-black text-white uppercase ml-7 mt-2 w-110px" onClick={close} type="button">cancel</button>
          <button className="font-americaMonoBold text-xs px-6 py-2 rounded-full bg-white text-black uppercase ml-7 mt-2 w-110px" onClick={() => saveObject(index)} type="button">save</button>
        </div> */}
      </div>
    </div>
  );
};

MamObjectFormMultiple.propTypes = {
  objState: PropTypes.shape().isRequired,
  inputObjHandler: PropTypes.func.isRequired,
  close: PropTypes.func,
  deleteObject: PropTypes.func,
  editor: PropTypes.bool,
  isPublic: PropTypes.bool,
  index: PropTypes.number,
};

MamObjectFormMultiple.defaultProps = {
  close: () => {},
  deleteObject: () => {},
  editor: false,
  isPublic: false,
  index: 0,
};

export default MamObjectFormMultiple;
